export default "__VITE_ASSET__Dn17fLsu__"